import React from "react";
import { Container } from "react-bootstrap";
import { setAudioOutputDeviceChanged, setDeviceForNotificationAudio, setEnableDisableDropDown } from "../../core/redux/notificationsSlice";
import { useAppDispatch, useAppSelector } from "../../core/redux/hooks";
import { DisplayToaster } from "../../core/services/sharedService";

const DeviceChoice = React.memo<{ deviceChangeFlag?: boolean, deviceChangeCallBackFunction?: Function }>(({ deviceChangeFlag, deviceChangeCallBackFunction }) => {

    const [videoDevices, setVideoDevices] = React.useState<any>([]);
    const [audioDevices, setAudioDevices] = React.useState<any>([]);
    const [audioInputDevices, setAudioInputDevices] = React.useState<any>([]);
    const [selectedOption, setSelectedOption] = React.useState<{ selectedVideoDevice: string | null, selectedAudioOutputDevice: string | null, selectedAudioInputDevice: string | null }>({ selectedVideoDevice: localStorage.getItem('selectedVideoDevice') ? localStorage.getItem('selectedVideoDevice') : null, selectedAudioOutputDevice: localStorage.getItem('selectedAudioOutputDevice') ? localStorage.getItem('selectedAudioOutputDevice') : null, selectedAudioInputDevice: localStorage.getItem('selectedAudioInputDevice') ? localStorage.getItem('selectedAudioInputDevice') : null });

    const dispatch = useAppDispatch();

    let notificationsSliceSelector = useAppSelector(
        (state: any) => state.agentNotification
    );

    const getAvailableDevices = React.useCallback(async () => {

        navigator.mediaDevices.getUserMedia({ audio: true, video: true }).then(mediaStream => {
            // if (!navigator.mediaDevices.selectAudioOutput) {
            //     console.log("selectAudioOutput() not supported.");
            //     return;
            // }
            mediaStream.getTracks().forEach(function (track) {
                track.stop();
            });
            navigator.mediaDevices.enumerateDevices().then(devices => {
                // console.log(devices, 'devices');
                const availableVideoDevices = devices.filter(device => device.kind === 'videoinput');
                const availableAudioDevices = devices.filter(device => device.kind === 'audiooutput');
                const availableAudioInputDevices = devices.filter(device => device.kind === 'audioinput');

                if (availableVideoDevices && availableAudioDevices && availableAudioInputDevices) {
                    setVideoDevices(availableVideoDevices);
                    setAudioDevices(availableAudioDevices);
                    setAudioInputDevices(availableAudioInputDevices);
                }
            }).catch((err: any) => {
                console.log(err, 'catch err');
            })
        }).catch(error => {
            console.log('Error :', error)
        })

    }, []);

    React.useEffect(() => {
        getAvailableDevices();
        try {
            navigator.mediaDevices.ondevicechange = (event) => {
                getAvailableDevices();
            };
        } catch {
            DisplayToaster("bg-danger", "Please grant access to camera and microphone.");
        }

    }, [getAvailableDevices])

    // React.useEffect(() => {
    //     dispatch(setAudioOutputDeviceChanged(true));
    // }, [selectedOption]);

    const handleDeviceChange = React.useCallback((htmlEvent: any, deviceType: "selectedVideoDevice" | "selectedAudioOutputDevice" | "selectedAudioInputDevice") => {
        localStorage.setItem(deviceType, htmlEvent.target.value);
        let changedSelectedDevice: any = {};
        changedSelectedDevice[deviceType] = htmlEvent.target.value;
        dispatch(setDeviceForNotificationAudio(changedSelectedDevice));
        dispatch(setEnableDisableDropDown(deviceType));
        dispatch(setAudioOutputDeviceChanged(true));
        if (deviceChangeFlag && deviceChangeCallBackFunction) {
            deviceChangeCallBackFunction();
        }
        setSelectedOption((previousDeviceSelection: { selectedVideoDevice: string | null, selectedAudioOutputDevice: string | null, selectedAudioInputDevice: string | null }) => {
            previousDeviceSelection[`${deviceType}`] = htmlEvent.target.value;
            return { ...previousDeviceSelection };
        })
    }, [deviceChangeCallBackFunction, deviceChangeFlag]);

    return (
        <>
            <Container fluid>

                {notificationsSliceSelector.enableDisable !== "" &&
                    <span className="spinner-border text-secondary mt-2 deviceChoice-spinner" style={{ width: '40px', height: "40px" }} role="status"></span>
                }
                <div className="row col-md-12 mt-2">
                    <div className="col-md-3">
                        <label>Video Device</label>
                    </div>
                    <div className="col-md-8">
                        <select
                            className="form-control"
                            onChange={(event) => { handleDeviceChange(event, 'selectedVideoDevice') }}
                            value={(selectedOption.selectedVideoDevice) ? selectedOption.selectedVideoDevice : ''}
                            disabled={notificationsSliceSelector.enableDisable === "selectedVideoDevice"}
                        >
                            {(selectedOption.selectedVideoDevice) ? <></> : <option value="">Select</option>}
                            {(videoDevices.length > 0) && videoDevices.map((items: any, i: number) => {
                                return <option key={i} value={items.deviceId} title={items.label} >{(items.label)}</option>
                            })}
                        </select>
                    </div>
                </div>

                <div className="row col-md-12 mt-2">
                    <div className="col-md-3">
                        <label>Audio Input Device</label>
                    </div>
                    <div className="col-md-8">
                        <select
                            className="form-control"
                            onChange={(event) => { handleDeviceChange(event, 'selectedAudioInputDevice') }}
                            value={(selectedOption.selectedAudioInputDevice) ? selectedOption.selectedAudioInputDevice : ''}
                            disabled={notificationsSliceSelector.enableDisable === "selectedAudioInputDevice"}
                        >
                            {(selectedOption.selectedAudioInputDevice) ? <></> : <option value="">Select</option>}
                            {(audioInputDevices.length > 0) && audioInputDevices.map((items: any, i: number) => {
                                return <option key={i} value={items.deviceId} title={items.label}>{(items.label)}</option>
                            })}
                        </select>
                    </div>
                </div>

                <div className="row col-md-12 mt-2">
                    <div className="col-md-3">
                        <label>Audio Output Device</label>
                    </div>
                    <div className="col-md-8">
                        <select
                            className="form-control"
                            onChange={(event) => { handleDeviceChange(event, 'selectedAudioOutputDevice') }}
                            value={(selectedOption.selectedAudioOutputDevice) ? selectedOption.selectedAudioOutputDevice : ''}
                            disabled={notificationsSliceSelector.enableDisable === "selectedAudioOutputDevice"}
                        >
                            {(selectedOption.selectedAudioOutputDevice) ? <></> : <option value="">Select</option>}
                            {(audioDevices.length > 0) && audioDevices.map((items: any, i: number) => {
                                return <option key={i} value={items.deviceId} title={items.label}>{(items.label)}</option>
                            })}
                        </select>
                    </div>
                </div>
            </Container>
        </>
    )
});

export default DeviceChoice;